module.exports = require("tinper-bee/assets/tinper-bee.css");